import { ProfileTarget } from "@welldigital/ui-common";
export const signUpTargets = JSON.parse(
  process.env.REACT_APP_SIGN_UP_TARGET_URLS || "{}"
) as Record<ProfileTarget, string>;

export const signUpURL = process.env.REACT_APP_LOGIN_SIGN_UP_FORM_URL!;
